import React from "react";
import { useNavigate } from "react-router-dom";

export const DreamTeamRow = ({ team }) => {
  const navigate = useNavigate();

  const handleViewTeamProfile = () => {
    navigate(`/scout/team/${team.id}`, {
      state: { teamData: team }
    });
  };

  return (
    <tr className="border-b border-slate-700/70 hover:bg-slate-800/40">
      <td className="px-3 py-2">
        <img src={team.logo} alt="" className="w-7 h-7 object-contain" />
      </td>
      <td className="px-3 py-2 text-slate-100">{team.name}</td>
      <td className="px-3 py-2 text-slate-200">{team.ovrRecord}</td>
      <td className="px-3 py-2 text-slate-200">{team.home}</td>
      <td className="px-3 py-2 text-slate-200">{team.away}</td>
      <td className="px-3 py-2 text-slate-200">{team.neutral}</td>
      <td className="px-3 py-2 text-slate-200">{team.conference}</td>
      <td className="px-3 py-2 text-right">
        <button
          onClick={handleViewTeamProfile}
          className="px-3 py-1 rounded-full text-[10px] border border-slate-300 text-slate-100 hover:bg-slate-700"
        >
          View team profile
        </button>
      </td>
    </tr>
  );
};
